import { render, staticRenderFns } from "./EnterNameRegister.vue?vue&type=template&id=08858827&scoped=true&"
import script from "./EnterNameRegister.vue?vue&type=script&lang=js&"
export * from "./EnterNameRegister.vue?vue&type=script&lang=js&"
import style0 from "./EnterNameRegister.vue?vue&type=style&index=0&id=08858827&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08858827",
  null
  
)

export default component.exports